import { render, staticRenderFns } from "./FormPriceSelect.vue?vue&type=template&id=4b094790&scoped=true&"
import script from "./FormPriceSelect.vue?vue&type=script&lang=ts&"
export * from "./FormPriceSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b094790",
  null
  
)

export default component.exports